export default __webpack_public_path__ + "static/media/inspiration3.f0b4c191.jpg";